import { render } from "preact";
import { Main } from "./components/Main";

render(<Main />, document.body);
